<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      formConfig: {},
    };
  },
  props: {
    propsObj: Object,
  },
  mounted() {
    this.params = { id: this.propsObj.row.id };
    this.getConfigList('product_log_list');
  },
  methods: {

  },
};
</script>
